const countriesAll = [
  {
    "id": 1,
    "name": "Singapore",
    "cynopsisName": null,
    "nationalityName": "Singaporean",
    "symbol": "SG",
    "flag": "https://flagcdn.com/w320/sg.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 1,
        "name": "Singapore Dollar",
        "symbol": "SGD",
        "currencySymbol": "S$",
        "imageUrl": "https://flagsapi.com/SG/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 1,
          "maxDecimalPlaces": 4,
          "isCashWithdrawEnabled": true,
          "isWalletEnabled": true
        }
      },
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      },
      {
        "id": 3,
        "name": "Philippine Peso",
        "symbol": "PHP",
        "currencySymbol": "₱",
        "imageUrl": "https://flagsapi.com/PH/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 3,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 4,
        "name": "Indonesian Rupiah",
        "symbol": "IDR",
        "currencySymbol": "Rp",
        "imageUrl": "https://flagsapi.com/ID/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 4,
          "maxDecimalPlaces": 4,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 5,
        "name": "Malaysian Ringgit",
        "symbol": "MYR",
        "currencySymbol": "RM",
        "imageUrl": "https://flagsapi.com/MY/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 5,
          "maxDecimalPlaces": 4,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 6,
        "name": "Chinese Yuan",
        "symbol": "CNY",
        "currencySymbol": "¥",
        "imageUrl": "https://flagsapi.com/CN/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 6,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 7,
        "name": "Thai Baht",
        "symbol": "THB",
        "currencySymbol": "฿",
        "imageUrl": "https://flagsapi.com/TH/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 7,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 8,
        "name": "Vietnamese Dong",
        "symbol": "VND",
        "currencySymbol": "₫",
        "imageUrl": "https://flagsapi.com/VN/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 8,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 9,
        "name": "Taiwan Dollar",
        "symbol": "TWD",
        "currencySymbol": "NT$",
        "imageUrl": "https://flagsapi.com/TW/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 9,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 10,
        "name": "Indian Rupee",
        "symbol": "INR",
        "currencySymbol": "₹",
        "imageUrl": "https://flagsapi.com/IN/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 10,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 11,
        "name": "Pakistani Rupee",
        "symbol": "PKR",
        "currencySymbol": "₨",
        "imageUrl": "https://flagsapi.com/PK/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 11,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 12,
        "name": "Hong Kong Dollar",
        "symbol": "HKD",
        "currencySymbol": "HK$",
        "imageUrl": "https://flagsapi.com/HK/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 12,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 13,
        "name": "Australian Dollar",
        "symbol": "AUD",
        "currencySymbol": "A$",
        "imageUrl": "https://flagsapi.com/AU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 13,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 14,
        "name": "Bangladeshi Taka",
        "symbol": "BDT",
        "currencySymbol": "৳",
        "imageUrl": "https://flagsapi.com/BD/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 14,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 15,
        "name": "Myanmar Kyat",
        "symbol": "MMK",
        "currencySymbol": "K",
        "imageUrl": "https://flagsapi.com/MM/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 15,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 16,
        "name": "UAE Dirham",
        "symbol": "AED",
        "currencySymbol": "د.إ",
        "imageUrl": "https://flagsapi.com/AE/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 16,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 17,
        "name": "Sri Lankan Rupee",
        "symbol": "LKR",
        "currencySymbol": "Rs",
        "imageUrl": "https://flagsapi.com/LK/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 17,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 18,
        "name": "Canadian Dollar",
        "symbol": "CAD",
        "currencySymbol": "C$",
        "imageUrl": "https://flagsapi.com/CA/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 18,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 19,
        "name": "South Korean Won",
        "symbol": "KRW",
        "currencySymbol": "₩",
        "imageUrl": "https://flagsapi.com/KR/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 19,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 20,
        "name": "British Pound",
        "symbol": "GBP",
        "currencySymbol": "£",
        "imageUrl": "https://flagsapi.com/GB/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 20,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 21,
        "name": "Brazilian Real",
        "symbol": "BRL",
        "currencySymbol": "R$",
        "imageUrl": "https://flagsapi.com/BR/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 21,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 23,
        "name": "Turkish Lira",
        "symbol": "TRY",
        "currencySymbol": "₺",
        "imageUrl": "https://flagsapi.com/TR/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 23,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 24,
        "name": "Nepalese Rupee",
        "symbol": "NPR",
        "currencySymbol": "Rs",
        "imageUrl": "https://flagsapi.com/NP/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 24,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 25,
        "name": "Japanese Yen",
        "symbol": "JPY",
        "currencySymbol": "¥",
        "imageUrl": "https://flagsapi.com/JP/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 25,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 26,
        "name": "New Zealand Dollar",
        "symbol": "NZD",
        "currencySymbol": "NZ$",
        "imageUrl": "https://flagsapi.com/NZ/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 26,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 27,
        "name": "Brunei Dollar",
        "symbol": "BND",
        "currencySymbol": "B$",
        "imageUrl": "https://flagsapi.com/BN/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 27,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 28,
        "name": "Saudi Arabian Riyal",
        "symbol": "SAR",
        "currencySymbol": "ر.س",
        "imageUrl": "https://flagsapi.com/SA/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 28,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 43,
        "name": "Moroccan Dirham",
        "symbol": "MAD",
        "currencySymbol": "د.م.",
        "imageUrl": "https://flagsapi.com/MAD/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 43,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": {
      "id": 17,
      "invoiceRequiredIndividualToIndividual": false,
      "invoiceRequiredIndividualToOrganization": false,
      "invoiceRequiredOrganizationToIndividual": false,
      "invoiceRequiredOrganizationToOrganization": false
    },
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "Nga Ngo",
    "lastModifiedDate": "2026-03-10T11:02:07.299555Z"
  },
  {
    "id": 2,
    "name": "Philippines",
    "cynopsisName": null,
    "nationalityName": "Filipino",
    "symbol": "PH",
    "flag": "https://flagcdn.com/w320/ph.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      },
      {
        "id": 3,
        "name": "Philippine Peso",
        "symbol": "PHP",
        "currencySymbol": "₱",
        "imageUrl": "https://flagsapi.com/PH/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 3,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 3,
        "name": "Philippine Peso",
        "symbol": "PHP",
        "currencySymbol": "₱",
        "imageUrl": "https://flagsapi.com/PH/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 3,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": {
      "id": 19,
      "invoiceRequiredIndividualToIndividual": true,
      "invoiceRequiredIndividualToOrganization": true,
      "invoiceRequiredOrganizationToIndividual": true,
      "invoiceRequiredOrganizationToOrganization": true
    },
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "Nga Ngo",
    "lastModifiedDate": "2026-03-10T10:56:16.028657Z"
  },
  {
    "id": 3,
    "name": "Indonesia",
    "cynopsisName": null,
    "nationalityName": "Indonesian",
    "symbol": "ID",
    "flag": "https://flagcdn.com/w320/id.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 4,
        "name": "Indonesian Rupiah",
        "symbol": "IDR",
        "currencySymbol": "Rp",
        "imageUrl": "https://flagsapi.com/ID/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 4,
          "maxDecimalPlaces": 4,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      },
      {
        "id": 5,
        "name": "Malaysian Ringgit",
        "symbol": "MYR",
        "currencySymbol": "RM",
        "imageUrl": "https://flagsapi.com/MY/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 5,
          "maxDecimalPlaces": 4,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": {
      "id": 21,
      "invoiceRequiredIndividualToIndividual": false,
      "invoiceRequiredIndividualToOrganization": true,
      "invoiceRequiredOrganizationToIndividual": true,
      "invoiceRequiredOrganizationToOrganization": true
    },
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "Phong Ngu",
    "lastModifiedDate": "2026-03-10T09:39:41.504857Z"
  },
  {
    "id": 4,
    "name": "Malaysia",
    "cynopsisName": null,
    "nationalityName": "Malaysian",
    "symbol": "MY",
    "flag": "https://flagcdn.com/w320/my.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 5,
        "name": "Malaysian Ringgit",
        "symbol": "MYR",
        "currencySymbol": "RM",
        "imageUrl": "https://flagsapi.com/MY/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 5,
          "maxDecimalPlaces": 4,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": {
      "id": 22,
      "invoiceRequiredIndividualToIndividual": true,
      "invoiceRequiredIndividualToOrganization": true,
      "invoiceRequiredOrganizationToIndividual": true,
      "invoiceRequiredOrganizationToOrganization": true
    },
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 5,
    "name": "China",
    "cynopsisName": null,
    "nationalityName": "Chinese",
    "symbol": "CN",
    "flag": "https://flagcdn.com/w320/cn.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": false,
    "localCurrencies": [
      {
        "id": 6,
        "name": "Chinese Yuan",
        "symbol": "CNY",
        "currencySymbol": "¥",
        "imageUrl": "https://flagsapi.com/CN/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 6,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 6,
        "name": "Chinese Yuan",
        "symbol": "CNY",
        "currencySymbol": "¥",
        "imageUrl": "https://flagsapi.com/CN/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 6,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": {
      "id": 18,
      "invoiceRequiredIndividualToIndividual": true,
      "invoiceRequiredIndividualToOrganization": true,
      "invoiceRequiredOrganizationToIndividual": true,
      "invoiceRequiredOrganizationToOrganization": true
    },
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "Nga Ngo",
    "lastModifiedDate": "2026-03-10T11:02:20.688914Z"
  },
  {
    "id": 6,
    "name": "Thailand",
    "cynopsisName": null,
    "nationalityName": "Thai",
    "symbol": "TH",
    "flag": "https://flagcdn.com/w320/th.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 1,
        "name": "Singapore Dollar",
        "symbol": "SGD",
        "currencySymbol": "S$",
        "imageUrl": "https://flagsapi.com/SG/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 1,
          "maxDecimalPlaces": 4,
          "isCashWithdrawEnabled": true,
          "isWalletEnabled": true
        }
      },
      {
        "id": 7,
        "name": "Thai Baht",
        "symbol": "THB",
        "currencySymbol": "฿",
        "imageUrl": "https://flagsapi.com/TH/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 7,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 1,
        "name": "Singapore Dollar",
        "symbol": "SGD",
        "currencySymbol": "S$",
        "imageUrl": "https://flagsapi.com/SG/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 1,
          "maxDecimalPlaces": 4,
          "isCashWithdrawEnabled": true,
          "isWalletEnabled": true
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 7,
    "name": "Vietnam",
    "cynopsisName": null,
    "nationalityName": "Vietnamese",
    "symbol": "VN",
    "flag": "https://flagcdn.com/w320/vn.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 8,
        "name": "Vietnamese Dong",
        "symbol": "VND",
        "currencySymbol": "₫",
        "imageUrl": "https://flagsapi.com/VN/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 8,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 1,
        "name": "Singapore Dollar",
        "symbol": "SGD",
        "currencySymbol": "S$",
        "imageUrl": "https://flagsapi.com/SG/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 1,
          "maxDecimalPlaces": 4,
          "isCashWithdrawEnabled": true,
          "isWalletEnabled": true
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 8,
    "name": "Taiwan",
    "cynopsisName": null,
    "nationalityName": "Taiwanese",
    "symbol": "TW",
    "flag": "https://flagcdn.com/w320/tw.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 9,
        "name": "Taiwan Dollar",
        "symbol": "TWD",
        "currencySymbol": "NT$",
        "imageUrl": "https://flagsapi.com/TW/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 9,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 9,
    "name": "India",
    "cynopsisName": null,
    "nationalityName": "Indian",
    "symbol": "IN",
    "flag": "https://flagcdn.com/w320/in.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 10,
        "name": "Indian Rupee",
        "symbol": "INR",
        "currencySymbol": "₹",
        "imageUrl": "https://flagsapi.com/IN/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 10,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 10,
    "name": "Pakistan",
    "cynopsisName": null,
    "nationalityName": "Pakistani",
    "symbol": "PK",
    "flag": "https://flagcdn.com/w320/pk.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 11,
        "name": "Pakistani Rupee",
        "symbol": "PKR",
        "currencySymbol": "₨",
        "imageUrl": "https://flagsapi.com/PK/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 11,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 11,
    "name": "Hong Kong",
    "cynopsisName": null,
    "nationalityName": "Hong Konger",
    "symbol": "HK",
    "flag": "https://flagcdn.com/w320/hk.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      },
      {
        "id": 12,
        "name": "Hong Kong Dollar",
        "symbol": "HKD",
        "currencySymbol": "HK$",
        "imageUrl": "https://flagsapi.com/HK/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 12,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 12,
        "name": "Hong Kong Dollar",
        "symbol": "HKD",
        "currencySymbol": "HK$",
        "imageUrl": "https://flagsapi.com/HK/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 12,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": {
      "id": 20,
      "invoiceRequiredIndividualToIndividual": false,
      "invoiceRequiredIndividualToOrganization": false,
      "invoiceRequiredOrganizationToIndividual": false,
      "invoiceRequiredOrganizationToOrganization": false
    },
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 12,
    "name": "Australia",
    "cynopsisName": null,
    "nationalityName": "Australian",
    "symbol": "AU",
    "flag": "https://flagcdn.com/w320/au.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 13,
        "name": "Australian Dollar",
        "symbol": "AUD",
        "currencySymbol": "A$",
        "imageUrl": "https://flagsapi.com/AU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 13,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": {
      "id": 24,
      "invoiceRequiredIndividualToIndividual": false,
      "invoiceRequiredIndividualToOrganization": false,
      "invoiceRequiredOrganizationToIndividual": false,
      "invoiceRequiredOrganizationToOrganization": false
    },
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 13,
    "name": "Bangladesh",
    "cynopsisName": null,
    "nationalityName": "Bangladeshi",
    "symbol": "BD",
    "flag": "https://flagcdn.com/w320/bd.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 14,
        "name": "Bangladeshi Taka",
        "symbol": "BDT",
        "currencySymbol": "৳",
        "imageUrl": "https://flagsapi.com/BD/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 14,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 14,
    "name": "Myanmar",
    "cynopsisName": "BURMA (REPUBLIC OF THE UNION OF MYANMAR)",
    "nationalityName": "Myanmar",
    "symbol": "MM",
    "flag": "https://flagcdn.com/w320/mm.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 15,
        "name": "Myanmar Kyat",
        "symbol": "MMK",
        "currencySymbol": "K",
        "imageUrl": "https://flagsapi.com/MM/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 15,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 15,
    "name": "United Arab Emirates",
    "cynopsisName": null,
    "nationalityName": "Emirati",
    "symbol": "AE",
    "flag": "https://flagcdn.com/w320/ae.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 16,
        "name": "UAE Dirham",
        "symbol": "AED",
        "currencySymbol": "د.إ",
        "imageUrl": "https://flagsapi.com/AE/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 16,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 16,
    "name": "Sri Lanka",
    "cynopsisName": null,
    "nationalityName": "Sri Lankan",
    "symbol": "LK",
    "flag": "https://flagcdn.com/w320/lk.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 17,
        "name": "Sri Lankan Rupee",
        "symbol": "LKR",
        "currencySymbol": "Rs",
        "imageUrl": "https://flagsapi.com/LK/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 17,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 17,
    "name": "Canada",
    "cynopsisName": null,
    "nationalityName": "Canadian",
    "symbol": "CA",
    "flag": "https://flagcdn.com/w320/ca.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 18,
        "name": "Canadian Dollar",
        "symbol": "CAD",
        "currencySymbol": "C$",
        "imageUrl": "https://flagsapi.com/CA/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 18,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 18,
    "name": "South Korea",
    "cynopsisName": null,
    "nationalityName": "South Korean",
    "symbol": "KR",
    "flag": "https://flagcdn.com/w320/kr.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 19,
        "name": "South Korean Won",
        "symbol": "KRW",
        "currencySymbol": "₩",
        "imageUrl": "https://flagsapi.com/KR/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 19,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 19,
    "name": "United States of America",
    "cynopsisName": null,
    "nationalityName": "American",
    "symbol": "US",
    "flag": "https://flagcdn.com/w320/us.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 20,
    "name": "United Kingdom",
    "cynopsisName": null,
    "nationalityName": "British",
    "symbol": "GB",
    "flag": "https://flagcdn.com/w320/gb.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 20,
        "name": "British Pound",
        "symbol": "GBP",
        "currencySymbol": "£",
        "imageUrl": "https://flagsapi.com/GB/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 20,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 21,
    "name": "Cambodia",
    "cynopsisName": null,
    "nationalityName": "Cambodian",
    "symbol": "KH",
    "flag": "https://flagcdn.com/w320/kh.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 22,
    "name": "Brazil",
    "cynopsisName": null,
    "nationalityName": "Brazilian",
    "symbol": "BR",
    "flag": "https://flagcdn.com/w320/br.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 21,
        "name": "Brazilian Real",
        "symbol": "BRL",
        "currencySymbol": "R$",
        "imageUrl": "https://flagsapi.com/BR/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 21,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 23,
    "name": "Austria",
    "cynopsisName": null,
    "nationalityName": "Austrian",
    "symbol": "AT",
    "flag": "https://flagcdn.com/w320/at.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 24,
    "name": "Belgium",
    "cynopsisName": null,
    "nationalityName": "Belgian",
    "symbol": "BE",
    "flag": "https://flagcdn.com/w320/be.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 25,
    "name": "Bulgaria",
    "cynopsisName": null,
    "nationalityName": "Bulgarian",
    "symbol": "BG",
    "flag": "https://flagcdn.com/w320/bg.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 26,
    "name": "Croatia",
    "cynopsisName": null,
    "nationalityName": "Croatian",
    "symbol": "HR",
    "flag": "https://flagcdn.com/w320/hr.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 27,
    "name": "Cyprus",
    "cynopsisName": null,
    "nationalityName": "Cypriot",
    "symbol": "CY",
    "flag": "https://flagcdn.com/w320/cy.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 28,
    "name": "Czech Republic",
    "cynopsisName": null,
    "nationalityName": "Czech",
    "symbol": "CZ",
    "flag": "https://flagcdn.com/w320/cz.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 29,
    "name": "Denmark",
    "cynopsisName": null,
    "nationalityName": "Danish",
    "symbol": "DK",
    "flag": "https://flagcdn.com/w320/dk.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      }
    ],
    "countrySetting": {
      "id": 26,
      "invoiceRequiredIndividualToIndividual": true,
      "invoiceRequiredIndividualToOrganization": false,
      "invoiceRequiredOrganizationToIndividual": false,
      "invoiceRequiredOrganizationToOrganization": false
    },
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 30,
    "name": "Estonia",
    "cynopsisName": null,
    "nationalityName": "Estonian",
    "symbol": "EE",
    "flag": "https://flagcdn.com/w320/ee.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 31,
    "name": "Finland",
    "cynopsisName": null,
    "nationalityName": "Finnish",
    "symbol": "FI",
    "flag": "https://flagcdn.com/w320/fi.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 32,
    "name": "France",
    "cynopsisName": null,
    "nationalityName": "French",
    "symbol": "FR",
    "flag": "https://flagcdn.com/w320/fr.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 33,
    "name": "Germany",
    "cynopsisName": null,
    "nationalityName": "German",
    "symbol": "DE",
    "flag": "https://flagcdn.com/w320/de.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": {
      "id": 25,
      "invoiceRequiredIndividualToIndividual": true,
      "invoiceRequiredIndividualToOrganization": true,
      "invoiceRequiredOrganizationToIndividual": true,
      "invoiceRequiredOrganizationToOrganization": true
    },
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 34,
    "name": "Greece",
    "cynopsisName": null,
    "nationalityName": "Greek",
    "symbol": "GR",
    "flag": "https://flagcdn.com/w320/gr.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 35,
    "name": "Hungary",
    "cynopsisName": null,
    "nationalityName": "Hungarian",
    "symbol": "HU",
    "flag": "https://flagcdn.com/w320/hu.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 36,
    "name": "Ireland",
    "cynopsisName": null,
    "nationalityName": "Irish",
    "symbol": "IE",
    "flag": "https://flagcdn.com/w320/ie.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 37,
    "name": "Italy",
    "cynopsisName": null,
    "nationalityName": "Italian",
    "symbol": "IT",
    "flag": "https://flagcdn.com/w320/it.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 38,
    "name": "Latvia",
    "cynopsisName": null,
    "nationalityName": "Latvian",
    "symbol": "LV",
    "flag": "https://flagcdn.com/w320/lv.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 39,
    "name": "Lithuania",
    "cynopsisName": null,
    "nationalityName": "Lithuanian",
    "symbol": "LT",
    "flag": "https://flagcdn.com/w320/lt.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 40,
    "name": "Luxembourg",
    "cynopsisName": null,
    "nationalityName": "Luxembourgish",
    "symbol": "LU",
    "flag": "https://flagcdn.com/w320/lu.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": {
      "id": 23,
      "invoiceRequiredIndividualToIndividual": true,
      "invoiceRequiredIndividualToOrganization": false,
      "invoiceRequiredOrganizationToIndividual": false,
      "invoiceRequiredOrganizationToOrganization": false
    },
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 41,
    "name": "Malta",
    "cynopsisName": null,
    "nationalityName": "Maltese",
    "symbol": "MT",
    "flag": "https://flagcdn.com/w320/mt.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 42,
    "name": "Netherlands",
    "cynopsisName": null,
    "nationalityName": "Dutch",
    "symbol": "NL",
    "flag": "https://flagcdn.com/w320/nl.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 43,
    "name": "Poland",
    "cynopsisName": null,
    "nationalityName": "Polish",
    "symbol": "PL",
    "flag": "https://flagcdn.com/w320/pl.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 44,
    "name": "Portugal",
    "cynopsisName": null,
    "nationalityName": "Portuguese",
    "symbol": "PT",
    "flag": "https://flagcdn.com/w320/pt.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 45,
    "name": "Romania",
    "cynopsisName": null,
    "nationalityName": "Romanian",
    "symbol": "RO",
    "flag": "https://flagcdn.com/w320/ro.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 46,
    "name": "Slovakia",
    "cynopsisName": null,
    "nationalityName": "Slovak",
    "symbol": "SK",
    "flag": "https://flagcdn.com/w320/sk.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 47,
    "name": "Slovenia",
    "cynopsisName": null,
    "nationalityName": "Slovenian",
    "symbol": "SI",
    "flag": "https://flagcdn.com/w320/si.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 48,
    "name": "Spain",
    "cynopsisName": null,
    "nationalityName": "Spanish",
    "symbol": "ES",
    "flag": "https://flagcdn.com/w320/es.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 49,
    "name": "Sweden",
    "cynopsisName": null,
    "nationalityName": "Swedish",
    "symbol": "SE",
    "flag": "https://flagcdn.com/w320/se.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 50,
    "name": "Turkey",
    "cynopsisName": null,
    "nationalityName": "Turkish",
    "symbol": "TR",
    "flag": "https://flagcdn.com/w320/tr.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 23,
        "name": "Turkish Lira",
        "symbol": "TRY",
        "currencySymbol": "₺",
        "imageUrl": "https://flagsapi.com/TR/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 23,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 51,
    "name": "Nepal",
    "cynopsisName": null,
    "nationalityName": "Nepalese",
    "symbol": "NP",
    "flag": "https://flagcdn.com/w320/np.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 24,
        "name": "Nepalese Rupee",
        "symbol": "NPR",
        "currencySymbol": "Rs",
        "imageUrl": "https://flagsapi.com/NP/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 24,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 52,
    "name": "Japan",
    "cynopsisName": null,
    "nationalityName": "Japanese",
    "symbol": "JP",
    "flag": "https://flagcdn.com/w320/jp.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 25,
        "name": "Japanese Yen",
        "symbol": "JPY",
        "currencySymbol": "¥",
        "imageUrl": "https://flagsapi.com/JP/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 25,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 53,
    "name": "New Zealand",
    "cynopsisName": null,
    "nationalityName": "New Zealander",
    "symbol": "NZ",
    "flag": "https://flagcdn.com/w320/nz.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 26,
        "name": "New Zealand Dollar",
        "symbol": "NZD",
        "currencySymbol": "NZ$",
        "imageUrl": "https://flagsapi.com/NZ/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 26,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 54,
    "name": "Brunei",
    "cynopsisName": null,
    "nationalityName": "Bruneian",
    "symbol": "BN",
    "flag": "https://flagcdn.com/w320/bn.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 27,
        "name": "Brunei Dollar",
        "symbol": "BND",
        "currencySymbol": "B$",
        "imageUrl": "https://flagsapi.com/BN/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 27,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 55,
    "name": "Saudi Arabia",
    "cynopsisName": null,
    "nationalityName": "Saudi Arabian",
    "symbol": "SA",
    "flag": "https://flagcdn.com/w320/sa.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 28,
        "name": "Saudi Arabian Riyal",
        "symbol": "SAR",
        "currencySymbol": "ر.س",
        "imageUrl": "https://flagsapi.com/SA/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 28,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2025-10-10T02:16:12.436637Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2025-10-10T02:16:12.436637Z"
  },
  {
    "id": 56,
    "name": "Afghanistan",
    "cynopsisName": null,
    "nationalityName": "Afghan",
    "symbol": "AF",
    "flag": "https://flagcdn.com/w320/af.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 57,
    "name": "Albania",
    "cynopsisName": null,
    "nationalityName": "Albanian",
    "symbol": "AL",
    "flag": "https://flagcdn.com/w320/al.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 58,
    "name": "Algeria",
    "cynopsisName": null,
    "nationalityName": "Algerian",
    "symbol": "DZ",
    "flag": "https://flagcdn.com/w320/dz.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 59,
    "name": "Andorra",
    "cynopsisName": null,
    "nationalityName": "Andorran",
    "symbol": "AD",
    "flag": "https://flagcdn.com/w320/ad.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 60,
    "name": "Angola",
    "cynopsisName": null,
    "nationalityName": "Angolan",
    "symbol": "AO",
    "flag": "https://flagcdn.com/w320/ao.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 61,
    "name": "Anguilla",
    "cynopsisName": null,
    "nationalityName": "Anguillan",
    "symbol": "AI",
    "flag": "https://flagcdn.com/w320/ai.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 62,
    "name": "Antigua",
    "cynopsisName": null,
    "nationalityName": "Antiguan",
    "symbol": "AG",
    "flag": "https://flagcdn.com/w320/ag.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 63,
    "name": "Argentina",
    "cynopsisName": null,
    "nationalityName": "Argentinian",
    "symbol": "AR",
    "flag": "https://flagcdn.com/w320/ar.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 33,
        "name": "Peso Argentina",
        "symbol": "ARS",
        "currencySymbol": "Arg$",
        "imageUrl": "https://flagsapi.com/ARS/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 33,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 33,
        "name": "Peso Argentina",
        "symbol": "ARS",
        "currencySymbol": "Arg$",
        "imageUrl": "https://flagsapi.com/ARS/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 33,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 64,
    "name": "Armenia",
    "cynopsisName": null,
    "nationalityName": "Armenian",
    "symbol": "AM",
    "flag": "https://flagcdn.com/w320/am.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 65,
    "name": "Aruba",
    "cynopsisName": null,
    "nationalityName": "Aruban",
    "symbol": "AB",
    "flag": "https://flagcdn.com/w320/aw.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 66,
    "name": "Azerbaijan",
    "cynopsisName": null,
    "nationalityName": "Azerbaijani",
    "symbol": "AZ",
    "flag": "https://flagcdn.com/w320/az.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 67,
    "name": "Bahamas",
    "cynopsisName": null,
    "nationalityName": "Bahamian",
    "symbol": "BS",
    "flag": "https://flagcdn.com/w320/bs.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 68,
    "name": "Bahrain",
    "cynopsisName": null,
    "nationalityName": "Bahraini",
    "symbol": "BH",
    "flag": "https://flagcdn.com/w320/bh.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 69,
    "name": "Barbados",
    "cynopsisName": null,
    "nationalityName": "Barbadian",
    "symbol": "BB",
    "flag": "https://flagcdn.com/w320/bb.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 70,
    "name": "Belarus",
    "cynopsisName": null,
    "nationalityName": "Belarussian",
    "symbol": "BL",
    "flag": "https://flagcdn.com/w320/by.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 71,
    "name": "Belize",
    "cynopsisName": null,
    "nationalityName": "Belizean",
    "symbol": "BZ",
    "flag": "https://flagcdn.com/w320/bz.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 72,
    "name": "Benin",
    "cynopsisName": null,
    "nationalityName": "Beninese",
    "symbol": "BJ",
    "flag": "https://flagcdn.com/w320/bj.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 73,
    "name": "Bermuda",
    "cynopsisName": null,
    "nationalityName": "Bermudan",
    "symbol": "BM",
    "flag": "https://flagcdn.com/w320/bm.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 74,
    "name": "Bhutan",
    "cynopsisName": null,
    "nationalityName": "Bhutanese",
    "symbol": "BT",
    "flag": "https://flagcdn.com/w320/bt.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 75,
    "name": "Bolivia",
    "cynopsisName": null,
    "nationalityName": "Bolivian",
    "symbol": "BO",
    "flag": "https://flagcdn.com/w320/bo.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 76,
    "name": "Bosnia-Herzegovina",
    "cynopsisName": null,
    "nationalityName": "Bosnian",
    "symbol": "BA",
    "flag": "https://flagcdn.com/w320/ba.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 77,
    "name": "Botswana",
    "cynopsisName": null,
    "nationalityName": "Botswanan",
    "symbol": "BW",
    "flag": "https://flagcdn.com/w320/bw.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 78,
    "name": "Burkina Faso",
    "cynopsisName": null,
    "nationalityName": "Burkinabe",
    "symbol": "BF",
    "flag": "https://flagcdn.com/w320/bf.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 79,
    "name": "Burundi",
    "cynopsisName": null,
    "nationalityName": "Burundian",
    "symbol": "BI",
    "flag": "https://flagcdn.com/w320/bi.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 80,
    "name": "Cape Verde",
    "cynopsisName": null,
    "nationalityName": "Cape Verdean",
    "symbol": "CV",
    "flag": "https://flagcdn.com/w320/cv.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 81,
    "name": "Cameroon",
    "cynopsisName": null,
    "nationalityName": "Cameroonian",
    "symbol": "CM",
    "flag": "https://flagcdn.com/w320/cm.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 82,
    "name": "Cayman Islands",
    "cynopsisName": null,
    "nationalityName": "Caymanian",
    "symbol": "KY",
    "flag": "https://flagcdn.com/w320/ky.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 83,
    "name": "Central African Republic",
    "cynopsisName": null,
    "nationalityName": "Central African",
    "symbol": "CF",
    "flag": "https://flagcdn.com/w320/cf.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 84,
    "name": "Chad",
    "cynopsisName": null,
    "nationalityName": "Chadian",
    "symbol": "TD",
    "flag": "https://flagcdn.com/w320/td.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 85,
    "name": "Chile",
    "cynopsisName": null,
    "nationalityName": "Chilean",
    "symbol": "CL",
    "flag": "https://flagcdn.com/w320/cl.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 86,
    "name": "Colombia",
    "cynopsisName": null,
    "nationalityName": "Colombian",
    "symbol": "CO",
    "flag": "https://flagcdn.com/w320/co.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 87,
    "name": "Comoros",
    "cynopsisName": null,
    "nationalityName": "Comoran",
    "symbol": "KM",
    "flag": "https://flagcdn.com/w320/km.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 88,
    "name": "Congo",
    "cynopsisName": null,
    "nationalityName": "Congolese",
    "symbol": "CG",
    "flag": "https://flagcdn.com/w320/cg.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 89,
    "name": "Costa Rica",
    "cynopsisName": null,
    "nationalityName": "Costa Rican",
    "symbol": "CR",
    "flag": "https://flagcdn.com/w320/cr.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 90,
    "name": "Cuba",
    "cynopsisName": null,
    "nationalityName": "Cuban",
    "symbol": "CU",
    "flag": "https://flagcdn.com/w320/cu.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 91,
    "name": "Djibouti",
    "cynopsisName": null,
    "nationalityName": "Djiboutian",
    "symbol": "DJ",
    "flag": "https://flagcdn.com/w320/dj.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 92,
    "name": "Dominica",
    "cynopsisName": null,
    "nationalityName": "Dominican",
    "symbol": "DM",
    "flag": "https://flagcdn.com/w320/dm.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 93,
    "name": "Dominican Republic",
    "cynopsisName": null,
    "nationalityName": "Dominican (Republic)",
    "symbol": "DO",
    "flag": "https://flagcdn.com/w320/do.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 94,
    "name": "Ecuador",
    "cynopsisName": null,
    "nationalityName": "Ecuadorian",
    "symbol": "EC",
    "flag": "https://flagcdn.com/w320/ec.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 95,
    "name": "Egypt",
    "cynopsisName": null,
    "nationalityName": "Egyptian",
    "symbol": "EG",
    "flag": "https://flagcdn.com/w320/eg.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 96,
    "name": "El Salvador",
    "cynopsisName": null,
    "nationalityName": "Salvadoran",
    "symbol": "SV",
    "flag": "https://flagcdn.com/w320/sv.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 97,
    "name": "Equatorial Guinea",
    "cynopsisName": null,
    "nationalityName": "Equatorial Guinean",
    "symbol": "GQ",
    "flag": "https://flagcdn.com/w320/gq.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 98,
    "name": "Eritrea",
    "cynopsisName": null,
    "nationalityName": "Eritrean",
    "symbol": "ER",
    "flag": "https://flagcdn.com/w320/er.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 99,
    "name": "Eswatini",
    "cynopsisName": null,
    "nationalityName": "Swazi",
    "symbol": "EW",
    "flag": "https://flagcdn.com/w320/sz.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 100,
    "name": "Ethiopia",
    "cynopsisName": null,
    "nationalityName": "Ethiopian",
    "symbol": "ET",
    "flag": "https://flagcdn.com/w320/et.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 101,
    "name": "Fiji",
    "cynopsisName": null,
    "nationalityName": "Fijian",
    "symbol": "FJ",
    "flag": "https://flagcdn.com/w320/fj.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 102,
    "name": "Gabon",
    "cynopsisName": null,
    "nationalityName": "Gabonese",
    "symbol": "GA",
    "flag": "https://flagcdn.com/w320/ga.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 103,
    "name": "Gambia",
    "cynopsisName": null,
    "nationalityName": "Gambian",
    "symbol": "GM",
    "flag": "https://flagcdn.com/w320/gm.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 104,
    "name": "Georgia",
    "cynopsisName": null,
    "nationalityName": "Georgian",
    "symbol": "GO",
    "flag": "https://flagcdn.com/w320/ge.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 105,
    "name": "Ghana",
    "cynopsisName": null,
    "nationalityName": "Ghanaian",
    "symbol": "GH",
    "flag": "https://flagcdn.com/w320/gh.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 106,
    "name": "Gibraltar",
    "cynopsisName": null,
    "nationalityName": "Gibraltarian",
    "symbol": "GI",
    "flag": "https://flagcdn.com/w320/gi.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 107,
    "name": "Grenada",
    "cynopsisName": null,
    "nationalityName": "Grenadian",
    "symbol": "GD",
    "flag": "https://flagcdn.com/w320/gd.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 108,
    "name": "Guatemala",
    "cynopsisName": null,
    "nationalityName": "Guatemalan",
    "symbol": "GT",
    "flag": "https://flagcdn.com/w320/gt.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 109,
    "name": "Guinea",
    "cynopsisName": null,
    "nationalityName": "Guinean",
    "symbol": "GN",
    "flag": "https://flagcdn.com/w320/gn.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 110,
    "name": "Guinea-Bissau",
    "cynopsisName": null,
    "nationalityName": "Guinean (Bissau)",
    "symbol": "GW",
    "flag": "https://flagcdn.com/w320/gw.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 111,
    "name": "Guyana",
    "cynopsisName": null,
    "nationalityName": "Guyanese",
    "symbol": "GY",
    "flag": "https://flagcdn.com/w320/gy.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 112,
    "name": "Haiti",
    "cynopsisName": null,
    "nationalityName": "Haitian",
    "symbol": "HT",
    "flag": "https://flagcdn.com/w320/ht.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 113,
    "name": "Honduras",
    "cynopsisName": null,
    "nationalityName": "Honduran",
    "symbol": "HN",
    "flag": "https://flagcdn.com/w320/hn.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 114,
    "name": "Iceland",
    "cynopsisName": null,
    "nationalityName": "Icelander",
    "symbol": "IS",
    "flag": "https://flagcdn.com/w320/is.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 115,
    "name": "Iran",
    "cynopsisName": null,
    "nationalityName": "Iranian",
    "symbol": "IR",
    "flag": "https://flagcdn.com/w320/ir.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 116,
    "name": "Iraq",
    "cynopsisName": null,
    "nationalityName": "Iraqi",
    "symbol": "IQ",
    "flag": "https://flagcdn.com/w320/iq.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 117,
    "name": "Israel",
    "cynopsisName": null,
    "nationalityName": "Israeli",
    "symbol": "IL",
    "flag": "https://flagcdn.com/w320/il.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 118,
    "name": "Ivory Coast",
    "cynopsisName": null,
    "nationalityName": "Ivorian",
    "symbol": "CI",
    "flag": "https://flagcdn.com/w320/ci.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 119,
    "name": "Jamaica",
    "cynopsisName": null,
    "nationalityName": "Jamaican",
    "symbol": "JM",
    "flag": "https://flagcdn.com/w320/jm.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 120,
    "name": "Jordan",
    "cynopsisName": null,
    "nationalityName": "Jordanian",
    "symbol": "JO",
    "flag": "https://flagcdn.com/w320/jo.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 121,
    "name": "Kazakhstan",
    "cynopsisName": null,
    "nationalityName": "Kazakhstani",
    "symbol": "KZ",
    "flag": "https://flagcdn.com/w320/kz.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 122,
    "name": "Kenya",
    "cynopsisName": null,
    "nationalityName": "Kenyan",
    "symbol": "KE",
    "flag": "https://flagcdn.com/w320/ke.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 123,
    "name": "Kiribati",
    "cynopsisName": null,
    "nationalityName": "Kiribati",
    "symbol": "KI",
    "flag": "https://flagcdn.com/w320/ki.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 124,
    "name": "Kosovo",
    "cynopsisName": null,
    "nationalityName": "Kosovar",
    "symbol": "KV",
    "flag": "https://flagcdn.com/w320/xk.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 125,
    "name": "Kuwait",
    "cynopsisName": null,
    "nationalityName": "Kuwaiti",
    "symbol": "KW",
    "flag": "https://flagcdn.com/w320/kw.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 126,
    "name": "Kyrgyzstan",
    "cynopsisName": null,
    "nationalityName": "Kyrgyz",
    "symbol": "KS",
    "flag": "https://flagcdn.com/w320/kg.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 127,
    "name": "Laos",
    "cynopsisName": null,
    "nationalityName": "Laotian",
    "symbol": "LA",
    "flag": "https://flagcdn.com/w320/la.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 128,
    "name": "Lebanon",
    "cynopsisName": null,
    "nationalityName": "Lebanese",
    "symbol": "LB",
    "flag": "https://flagcdn.com/w320/lb.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 129,
    "name": "Lesotho",
    "cynopsisName": null,
    "nationalityName": "Basotho",
    "symbol": "LS",
    "flag": "https://flagcdn.com/w320/ls.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 130,
    "name": "Liberia",
    "cynopsisName": null,
    "nationalityName": "Liberian",
    "symbol": "LR",
    "flag": "https://flagcdn.com/w320/lr.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 131,
    "name": "Libya",
    "cynopsisName": null,
    "nationalityName": "Libyan",
    "symbol": "LY",
    "flag": "https://flagcdn.com/w320/ly.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 132,
    "name": "Liechtenstein",
    "cynopsisName": null,
    "nationalityName": "Liechtensteiner",
    "symbol": "LI",
    "flag": "https://flagcdn.com/w320/li.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 133,
    "name": "Macao",
    "cynopsisName": null,
    "nationalityName": "Chinese/Macao SAR",
    "symbol": "MO",
    "flag": "https://flagcdn.com/w320/mo.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 134,
    "name": "Macedonia",
    "cynopsisName": null,
    "nationalityName": "Macedonian",
    "symbol": "MB",
    "flag": "https://flagcdn.com/w320/mk.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 135,
    "name": "Madagascar",
    "cynopsisName": null,
    "nationalityName": "Malagasy",
    "symbol": "MG",
    "flag": "https://flagcdn.com/w320/mg.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 136,
    "name": "Malawi",
    "cynopsisName": null,
    "nationalityName": "Malawian",
    "symbol": "MW",
    "flag": "https://flagcdn.com/w320/mw.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 137,
    "name": "Maldives",
    "cynopsisName": null,
    "nationalityName": "Maldivian",
    "symbol": "MV",
    "flag": "https://flagcdn.com/w320/mv.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 138,
    "name": "Mali",
    "cynopsisName": null,
    "nationalityName": "Malian",
    "symbol": "ML",
    "flag": "https://flagcdn.com/w320/ml.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 139,
    "name": "Marshall Islands",
    "cynopsisName": null,
    "nationalityName": "Marshallese",
    "symbol": "MH",
    "flag": "https://flagcdn.com/w320/mh.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 140,
    "name": "Mauritania",
    "cynopsisName": null,
    "nationalityName": "Mauritanian",
    "symbol": "MR",
    "flag": "https://flagcdn.com/w320/mr.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 141,
    "name": "Mauritius",
    "cynopsisName": null,
    "nationalityName": "Mauritian",
    "symbol": "MU",
    "flag": "https://flagcdn.com/w320/mu.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 142,
    "name": "Mexico",
    "cynopsisName": null,
    "nationalityName": "Mexican",
    "symbol": "MX",
    "flag": "https://flagcdn.com/w320/mx.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 143,
    "name": "Moldova",
    "cynopsisName": null,
    "nationalityName": "Moldavian",
    "symbol": "MD",
    "flag": "https://flagcdn.com/w320/md.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 144,
    "name": "Monaco",
    "cynopsisName": null,
    "nationalityName": "Monacan",
    "symbol": "MC",
    "flag": "https://flagcdn.com/w320/mc.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 145,
    "name": "Mongolia",
    "cynopsisName": null,
    "nationalityName": "Mongolian",
    "symbol": "MN",
    "flag": "https://flagcdn.com/w320/mn.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 146,
    "name": "Montenegro",
    "cynopsisName": null,
    "nationalityName": "Montenegrin",
    "symbol": "MJ",
    "flag": "https://flagcdn.com/w320/me.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 147,
    "name": "Montserrat",
    "cynopsisName": null,
    "nationalityName": "Montserratian",
    "symbol": "MS",
    "flag": "https://flagcdn.com/w320/ms.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 148,
    "name": "Morocco",
    "cynopsisName": null,
    "nationalityName": "Moroccan",
    "symbol": "MA",
    "flag": "https://flagcdn.com/w320/ma.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 149,
    "name": "Mozambique",
    "cynopsisName": null,
    "nationalityName": "Mozambican",
    "symbol": "MZ",
    "flag": "https://flagcdn.com/w320/mz.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 150,
    "name": "Namibia",
    "cynopsisName": null,
    "nationalityName": "Namibian",
    "symbol": "NA",
    "flag": "https://flagcdn.com/w320/na.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 151,
    "name": "Nauru",
    "cynopsisName": null,
    "nationalityName": "Nauruan",
    "symbol": "NR",
    "flag": "https://flagcdn.com/w320/nr.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 152,
    "name": "Nicaragua",
    "cynopsisName": null,
    "nationalityName": "Nicaraguan",
    "symbol": "NI",
    "flag": "https://flagcdn.com/w320/ni.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 153,
    "name": "Niger",
    "cynopsisName": null,
    "nationalityName": "Nigerien",
    "symbol": "NE",
    "flag": "https://flagcdn.com/w320/ne.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 154,
    "name": "Nigeria",
    "cynopsisName": null,
    "nationalityName": "Nigerian",
    "symbol": "NG",
    "flag": "https://flagcdn.com/w320/ng.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 155,
    "name": "North Korea",
    "cynopsisName": null,
    "nationalityName": "North Korean",
    "symbol": "KP",
    "flag": "https://flagcdn.com/w320/kp.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 156,
    "name": "Norway",
    "cynopsisName": null,
    "nationalityName": "Norwegian",
    "symbol": "NO",
    "flag": "https://flagcdn.com/w320/no.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 157,
    "name": "Oman",
    "cynopsisName": null,
    "nationalityName": "Omani",
    "symbol": "OM",
    "flag": "https://flagcdn.com/w320/om.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 158,
    "name": "Palau",
    "cynopsisName": null,
    "nationalityName": "Palauan",
    "symbol": "PW",
    "flag": "https://flagcdn.com/w320/pw.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 159,
    "name": "Palestine",
    "cynopsisName": null,
    "nationalityName": "Palestinian",
    "symbol": "PB",
    "flag": "https://flagcdn.com/w320/ps.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 160,
    "name": "Panama",
    "cynopsisName": null,
    "nationalityName": "Panamanian",
    "symbol": "PA",
    "flag": "https://flagcdn.com/w320/pa.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 161,
    "name": "Papua New Guinea",
    "cynopsisName": null,
    "nationalityName": "Papua New Guinean",
    "symbol": "PG",
    "flag": "https://flagcdn.com/w320/pg.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 162,
    "name": "Paraguay",
    "cynopsisName": null,
    "nationalityName": "Paraguayan",
    "symbol": "PY",
    "flag": "https://flagcdn.com/w320/py.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 163,
    "name": "Peru",
    "cynopsisName": null,
    "nationalityName": "Peruvian",
    "symbol": "PE",
    "flag": "https://flagcdn.com/w320/pe.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 164,
    "name": "Qatar",
    "cynopsisName": null,
    "nationalityName": "Qatari",
    "symbol": "QA",
    "flag": "https://flagcdn.com/w320/qa.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 165,
    "name": "Russia",
    "cynopsisName": null,
    "nationalityName": "Russian",
    "symbol": "RF",
    "flag": "https://flagcdn.com/w320/ru.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 166,
    "name": "Rwanda",
    "cynopsisName": null,
    "nationalityName": "Rwandan",
    "symbol": "RW",
    "flag": "https://flagcdn.com/w320/rw.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 167,
    "name": "San Marino",
    "cynopsisName": null,
    "nationalityName": "Sammarinese",
    "symbol": "SM",
    "flag": "https://flagcdn.com/w320/sm.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 168,
    "name": "Sao Tome & Principe",
    "cynopsisName": null,
    "nationalityName": "Sao Tomean",
    "symbol": "ST",
    "flag": "https://flagcdn.com/w320/st.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 169,
    "name": "Senegal",
    "cynopsisName": null,
    "nationalityName": "Senegalese",
    "symbol": "SN",
    "flag": "https://flagcdn.com/w320/sn.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 170,
    "name": "Serbia",
    "cynopsisName": null,
    "nationalityName": "Serbian",
    "symbol": "RS",
    "flag": "https://flagcdn.com/w320/rs.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 171,
    "name": "Seychelles",
    "cynopsisName": null,
    "nationalityName": "Seychellois",
    "symbol": "SC",
    "flag": "https://flagcdn.com/w320/sc.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 172,
    "name": "Sierra Leone",
    "cynopsisName": null,
    "nationalityName": "Sierra Leonean",
    "symbol": "SL",
    "flag": "https://flagcdn.com/w320/sl.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 173,
    "name": "Solomon Islands",
    "cynopsisName": null,
    "nationalityName": "Solomon Islander",
    "symbol": "SB",
    "flag": "https://flagcdn.com/w320/sb.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 174,
    "name": "Somalia",
    "cynopsisName": null,
    "nationalityName": "Somali",
    "symbol": "SO",
    "flag": "https://flagcdn.com/w320/so.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 175,
    "name": "South Africa",
    "cynopsisName": null,
    "nationalityName": "South African",
    "symbol": "ZA",
    "flag": "https://flagcdn.com/w320/za.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 176,
    "name": "South Sudan",
    "cynopsisName": null,
    "nationalityName": "South Sudanese",
    "symbol": "SX",
    "flag": "https://flagcdn.com/w320/ss.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 177,
    "name": "St. Kitts-Nevis",
    "cynopsisName": null,
    "nationalityName": "Kittian & Nevisian",
    "symbol": "KN",
    "flag": "https://flagcdn.com/w320/kn.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 178,
    "name": "St. Lucia",
    "cynopsisName": null,
    "nationalityName": "St. Lucian",
    "symbol": "LC",
    "flag": "https://flagcdn.com/w320/lc.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 179,
    "name": "St. Vincent",
    "cynopsisName": null,
    "nationalityName": "St. Vincentian",
    "symbol": "VC",
    "flag": "https://flagcdn.com/w320/vc.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 180,
    "name": "Sudan",
    "cynopsisName": null,
    "nationalityName": "Sudanese",
    "symbol": "SD",
    "flag": "https://flagcdn.com/w320/sd.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 181,
    "name": "Suriname",
    "cynopsisName": null,
    "nationalityName": "Surinamer",
    "symbol": "SR",
    "flag": "https://flagcdn.com/w320/sr.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 182,
    "name": "Switzerland",
    "cynopsisName": null,
    "nationalityName": "Swiss",
    "symbol": "CH",
    "flag": "https://flagcdn.com/w320/ch.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 183,
    "name": "Syria",
    "cynopsisName": null,
    "nationalityName": "Syrian",
    "symbol": "SY",
    "flag": "https://flagcdn.com/w320/sy.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 184,
    "name": "Tajikistan",
    "cynopsisName": null,
    "nationalityName": "Tajikistani",
    "symbol": "TI",
    "flag": "https://flagcdn.com/w320/tj.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 185,
    "name": "Tanzania",
    "cynopsisName": null,
    "nationalityName": "Tanzanian",
    "symbol": "TZ",
    "flag": "https://flagcdn.com/w320/tz.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 186,
    "name": "Togo",
    "cynopsisName": null,
    "nationalityName": "Togolese",
    "symbol": "TG",
    "flag": "https://flagcdn.com/w320/tg.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 187,
    "name": "Tonga",
    "cynopsisName": null,
    "nationalityName": "Tongan",
    "symbol": "TO",
    "flag": "https://flagcdn.com/w320/to.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 188,
    "name": "Trinidad & Tobago",
    "cynopsisName": null,
    "nationalityName": "Trinidadian & Tobagonian",
    "symbol": "TT",
    "flag": "https://flagcdn.com/w320/tt.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 189,
    "name": "Tunisia",
    "cynopsisName": null,
    "nationalityName": "Tunisian",
    "symbol": "TN",
    "flag": "https://flagcdn.com/w320/tn.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 190,
    "name": "Turkmenistan",
    "cynopsisName": null,
    "nationalityName": "Turkmen",
    "symbol": "TM",
    "flag": "https://flagcdn.com/w320/tm.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 191,
    "name": "Tuvalu",
    "cynopsisName": null,
    "nationalityName": "Tuvaluan",
    "symbol": "TV",
    "flag": "https://flagcdn.com/w320/tv.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 192,
    "name": "Uganda",
    "cynopsisName": null,
    "nationalityName": "Ugandan",
    "symbol": "UG",
    "flag": "https://flagcdn.com/w320/ug.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 193,
    "name": "Ukraine",
    "cynopsisName": null,
    "nationalityName": "Ukrainian",
    "symbol": "UR",
    "flag": "https://flagcdn.com/w320/ua.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 194,
    "name": "Uruguay",
    "cynopsisName": null,
    "nationalityName": "Uruguayan",
    "symbol": "UY",
    "flag": "https://flagcdn.com/w320/uy.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 195,
    "name": "Uzbekistan",
    "cynopsisName": null,
    "nationalityName": "Uzbekistani",
    "symbol": "UZ",
    "flag": "https://flagcdn.com/w320/uz.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 196,
    "name": "Vanuatu",
    "cynopsisName": null,
    "nationalityName": "Ni-Vanuatu",
    "symbol": "VU",
    "flag": "https://flagcdn.com/w320/vu.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 197,
    "name": "Vatican City State",
    "cynopsisName": null,
    "nationalityName": "Vatican",
    "symbol": "VA",
    "flag": "https://flagcdn.com/w320/va.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 198,
    "name": "Venezuela",
    "cynopsisName": null,
    "nationalityName": "Venezuelan",
    "symbol": "VE",
    "flag": "https://flagcdn.com/w320/ve.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 199,
    "name": "Yemen",
    "cynopsisName": null,
    "nationalityName": "Yemeni",
    "symbol": "YM",
    "flag": "https://flagcdn.com/w320/ye.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 200,
    "name": "Zambia",
    "cynopsisName": null,
    "nationalityName": "Zambian",
    "symbol": "ZM",
    "flag": "https://flagcdn.com/w320/zm.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 201,
    "name": "Zimbabwe",
    "cynopsisName": null,
    "nationalityName": "Zimbabwean",
    "symbol": "ZW",
    "flag": "https://flagcdn.com/w320/zw.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 3,
        "name": "Philippine Peso",
        "symbol": "PHP",
        "currencySymbol": "₱",
        "imageUrl": "https://flagsapi.com/PH/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 3,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 4,
        "name": "Indonesian Rupiah",
        "symbol": "IDR",
        "currencySymbol": "Rp",
        "imageUrl": "https://flagsapi.com/ID/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 4,
          "maxDecimalPlaces": 4,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 3,
        "name": "Philippine Peso",
        "symbol": "PHP",
        "currencySymbol": "₱",
        "imageUrl": "https://flagsapi.com/PH/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 3,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 5,
        "name": "Malaysian Ringgit",
        "symbol": "MYR",
        "currencySymbol": "RM",
        "imageUrl": "https://flagsapi.com/MY/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 5,
          "maxDecimalPlaces": 4,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 202,
    "name": "Democratic Republic of Congo",
    "cynopsisName": null,
    "nationalityName": "Congolese",
    "symbol": "ZR",
    "flag": "https://flagcdn.com/w320/cd.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 203,
    "name": "Timor",
    "cynopsisName": null,
    "nationalityName": "Timorese",
    "symbol": "TE",
    "flag": "https://flagcdn.com/w320/tl.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 204,
    "name": "East Timor",
    "cynopsisName": null,
    "nationalityName": "East Timorese",
    "symbol": "TP",
    "flag": "https://flagcdn.com/w320/tl.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [],
    "foreignCurrencies": [],
    "countrySetting": null,
    "createdBy": "SCRIPT",
    "createdDate": "2026-02-04T03:26:10.497962Z",
    "lastModifiedBy": "SCRIPT",
    "lastModifiedDate": "2026-02-04T03:26:10.497962Z"
  },
  {
    "id": 205,
    "name": "Happy land",
    "cynopsisName": null,
    "nationalityName": "Vuongese",
    "symbol": "VG",
    "flag": "https://flagcdn.com/w320/vg.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": false,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": false,
    "localCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      },
      {
        "id": 3,
        "name": "Philippine Peso",
        "symbol": "PHP",
        "currencySymbol": "₱",
        "imageUrl": "https://flagsapi.com/PH/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 3,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 4,
        "name": "Indonesian Rupiah",
        "symbol": "IDR",
        "currencySymbol": "Rp",
        "imageUrl": "https://flagsapi.com/ID/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 4,
          "maxDecimalPlaces": 4,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 5,
        "name": "Malaysian Ringgit",
        "symbol": "MYR",
        "currencySymbol": "RM",
        "imageUrl": "https://flagsapi.com/MY/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 5,
          "maxDecimalPlaces": 4,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 6,
        "name": "Chinese Yuan",
        "symbol": "CNY",
        "currencySymbol": "¥",
        "imageUrl": "https://flagsapi.com/CN/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 6,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 7,
        "name": "Thai Baht",
        "symbol": "THB",
        "currencySymbol": "฿",
        "imageUrl": "https://flagsapi.com/TH/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 7,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 8,
        "name": "Vietnamese Dong",
        "symbol": "VND",
        "currencySymbol": "₫",
        "imageUrl": "https://flagsapi.com/VN/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 8,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 9,
        "name": "Taiwan Dollar",
        "symbol": "TWD",
        "currencySymbol": "NT$",
        "imageUrl": "https://flagsapi.com/TW/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 9,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 10,
        "name": "Indian Rupee",
        "symbol": "INR",
        "currencySymbol": "₹",
        "imageUrl": "https://flagsapi.com/IN/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 10,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 11,
        "name": "Pakistani Rupee",
        "symbol": "PKR",
        "currencySymbol": "₨",
        "imageUrl": "https://flagsapi.com/PK/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 11,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 12,
        "name": "Hong Kong Dollar",
        "symbol": "HKD",
        "currencySymbol": "HK$",
        "imageUrl": "https://flagsapi.com/HK/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 12,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 13,
        "name": "Australian Dollar",
        "symbol": "AUD",
        "currencySymbol": "A$",
        "imageUrl": "https://flagsapi.com/AU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 13,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 14,
        "name": "Bangladeshi Taka",
        "symbol": "BDT",
        "currencySymbol": "৳",
        "imageUrl": "https://flagsapi.com/BD/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 14,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 15,
        "name": "Myanmar Kyat",
        "symbol": "MMK",
        "currencySymbol": "K",
        "imageUrl": "https://flagsapi.com/MM/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 15,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 16,
        "name": "UAE Dirham",
        "symbol": "AED",
        "currencySymbol": "د.إ",
        "imageUrl": "https://flagsapi.com/AE/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 16,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 17,
        "name": "Sri Lankan Rupee",
        "symbol": "LKR",
        "currencySymbol": "Rs",
        "imageUrl": "https://flagsapi.com/LK/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 17,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 18,
        "name": "Canadian Dollar",
        "symbol": "CAD",
        "currencySymbol": "C$",
        "imageUrl": "https://flagsapi.com/CA/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 18,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 19,
        "name": "South Korean Won",
        "symbol": "KRW",
        "currencySymbol": "₩",
        "imageUrl": "https://flagsapi.com/KR/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 19,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 20,
        "name": "British Pound",
        "symbol": "GBP",
        "currencySymbol": "£",
        "imageUrl": "https://flagsapi.com/GB/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 20,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 21,
        "name": "Brazilian Real",
        "symbol": "BRL",
        "currencySymbol": "R$",
        "imageUrl": "https://flagsapi.com/BR/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 21,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 23,
        "name": "Turkish Lira",
        "symbol": "TRY",
        "currencySymbol": "₺",
        "imageUrl": "https://flagsapi.com/TR/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 23,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 24,
        "name": "Nepalese Rupee",
        "symbol": "NPR",
        "currencySymbol": "Rs",
        "imageUrl": "https://flagsapi.com/NP/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 24,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 25,
        "name": "Japanese Yen",
        "symbol": "JPY",
        "currencySymbol": "¥",
        "imageUrl": "https://flagsapi.com/JP/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 25,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 26,
        "name": "New Zealand Dollar",
        "symbol": "NZD",
        "currencySymbol": "NZ$",
        "imageUrl": "https://flagsapi.com/NZ/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 26,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 27,
        "name": "Brunei Dollar",
        "symbol": "BND",
        "currencySymbol": "B$",
        "imageUrl": "https://flagsapi.com/BN/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 27,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 28,
        "name": "Saudi Arabian Riyal",
        "symbol": "SAR",
        "currencySymbol": "ر.س",
        "imageUrl": "https://flagsapi.com/SA/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 28,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Vuong",
    "createdDate": "2026-02-06T03:59:30.881134Z",
    "lastModifiedBy": "Vuong",
    "lastModifiedDate": "2026-02-06T08:28:03.896125Z"
  },
  {
    "id": 206,
    "name": "WONDERLAND",
    "cynopsisName": null,
    "nationalityName": "WONDERLANDESE",
    "symbol": "WD",
    "flag": "https://flagcdn.com/w320/wd.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": false,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": false,
    "localCurrencies": [
      {
        "id": 27,
        "name": "Brunei Dollar",
        "symbol": "BND",
        "currencySymbol": "B$",
        "imageUrl": "https://flagsapi.com/BN/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 27,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 28,
        "name": "Saudi Arabian Riyal",
        "symbol": "SAR",
        "currencySymbol": "ر.س",
        "imageUrl": "https://flagsapi.com/SA/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 28,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Vuong",
    "createdDate": "2026-02-06T08:31:01.374724Z",
    "lastModifiedBy": "Vuong",
    "lastModifiedDate": "2026-02-06T08:31:01.374724Z"
  },
  {
    "id": 207,
    "name": "American Samoa",
    "cynopsisName": null,
    "nationalityName": "American Samoa",
    "symbol": "AS",
    "flag": "https://flagcdn.com/w320/as.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": false,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": false,
    "localCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 13,
        "name": "Australian Dollar",
        "symbol": "AUD",
        "currencySymbol": "A$",
        "imageUrl": "https://flagsapi.com/AU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 13,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 26,
        "name": "New Zealand Dollar",
        "symbol": "NZD",
        "currencySymbol": "NZ$",
        "imageUrl": "https://flagsapi.com/NZ/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 26,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T08:33:06.745228Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T08:33:06.745228Z"
  },
  {
    "id": 208,
    "name": "Cook Islands",
    "cynopsisName": null,
    "nationalityName": "Cook Islander",
    "symbol": "CK",
    "flag": "https://flagcdn.com/w320/ck.png",
    "hasBankTransfer": false,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 26,
        "name": "New Zealand Dollar",
        "symbol": "NZD",
        "currencySymbol": "NZ$",
        "imageUrl": "https://flagsapi.com/NZ/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 26,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      },
      {
        "id": 13,
        "name": "Australian Dollar",
        "symbol": "AUD",
        "currencySymbol": "A$",
        "imageUrl": "https://flagsapi.com/AU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 13,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T08:34:21.318159Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T08:34:21.318159Z"
  },
  {
    "id": 209,
    "name": "GUAM",
    "cynopsisName": null,
    "nationalityName": "Guamanian",
    "symbol": "GU",
    "flag": "https://flagcdn.com/w320/pf.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 1,
        "name": "Singapore Dollar",
        "symbol": "SGD",
        "currencySymbol": "S$",
        "imageUrl": "https://flagsapi.com/SG/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 1,
          "maxDecimalPlaces": 4,
          "isCashWithdrawEnabled": true,
          "isWalletEnabled": true
        }
      },
      {
        "id": 19,
        "name": "South Korean Won",
        "symbol": "KRW",
        "currencySymbol": "₩",
        "imageUrl": "https://flagsapi.com/KR/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 19,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 25,
        "name": "Japanese Yen",
        "symbol": "JPY",
        "currencySymbol": "¥",
        "imageUrl": "https://flagsapi.com/JP/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 25,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T08:38:45.494922Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T08:38:45.494922Z"
  },
  {
    "id": 210,
    "name": "Micronesia",
    "cynopsisName": null,
    "nationalityName": "MicronesiaN",
    "symbol": "FM",
    "flag": "https://flagcdn.com/w320/fm.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 13,
        "name": "Australian Dollar",
        "symbol": "AUD",
        "currencySymbol": "A$",
        "imageUrl": "https://flagsapi.com/AU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 13,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 26,
        "name": "New Zealand Dollar",
        "symbol": "NZD",
        "currencySymbol": "NZ$",
        "imageUrl": "https://flagsapi.com/NZ/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 26,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T08:48:26.280563Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T08:48:26.280563Z"
  },
  {
    "id": 211,
    "name": "French Polynesia",
    "cynopsisName": null,
    "nationalityName": "French Polynesian",
    "symbol": "PF",
    "flag": "https://flagcdn.com/w320/pf.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": false,
    "localCurrencies": [
      {
        "id": 34,
        "name": "CFP Franc",
        "symbol": "XPF",
        "currencySymbol": "₣",
        "imageUrl": "https://flagsapi.com/XPF/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 34,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      },
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T08:58:37.394148Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T08:58:37.394148Z"
  },
  {
    "id": 212,
    "name": "New Caledonia",
    "cynopsisName": null,
    "nationalityName": "New Caledonian",
    "symbol": "NC",
    "flag": "https://flagcdn.com/w320/nc.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 34,
        "name": "CFP Franc",
        "symbol": "XPF",
        "currencySymbol": "₣",
        "imageUrl": "https://flagsapi.com/XPF/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 34,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 13,
        "name": "Australian Dollar",
        "symbol": "AUD",
        "currencySymbol": "A$",
        "imageUrl": "https://flagsapi.com/AU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 13,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T08:59:35.135200Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T08:59:35.135200Z"
  },
  {
    "id": 213,
    "name": "Niue",
    "cynopsisName": null,
    "nationalityName": "Niuean",
    "symbol": "NU",
    "flag": "https://flagcdn.com/w320/nu.png",
    "hasBankTransfer": false,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 26,
        "name": "New Zealand Dollar",
        "symbol": "NZD",
        "currencySymbol": "NZ$",
        "imageUrl": "https://flagsapi.com/NZ/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 26,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:00:53.763707Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:00:53.763707Z"
  },
  {
    "id": 214,
    "name": "Northern Mariana Islands",
    "cynopsisName": null,
    "nationalityName": "Northern Mariana Islander",
    "symbol": "MP",
    "flag": "https://flagcdn.com/w320/mp.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 3,
        "name": "Philippine Peso",
        "symbol": "PHP",
        "currencySymbol": "₱",
        "imageUrl": "https://flagsapi.com/PH/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 3,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 25,
        "name": "Japanese Yen",
        "symbol": "JPY",
        "currencySymbol": "¥",
        "imageUrl": "https://flagsapi.com/JP/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 25,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:01:56.819512Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:01:56.819512Z"
  },
  {
    "id": 215,
    "name": "Samoa",
    "cynopsisName": null,
    "nationalityName": "Samoan",
    "symbol": "WS",
    "flag": "https://flagcdn.com/w320/ws.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 35,
        "name": "Samoan Tala",
        "symbol": "WST",
        "currencySymbol": "T",
        "imageUrl": "https://flagsapi.com/WST/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 35,
          "maxDecimalPlaces": 1,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      },
      {
        "id": 13,
        "name": "Australian Dollar",
        "symbol": "AUD",
        "currencySymbol": "A$",
        "imageUrl": "https://flagsapi.com/AU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 13,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 26,
        "name": "New Zealand Dollar",
        "symbol": "NZD",
        "currencySymbol": "NZ$",
        "imageUrl": "https://flagsapi.com/NZ/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 26,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:03:27.931394Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:03:27.931394Z"
  },
  {
    "id": 216,
    "name": "Wallis and Futuna",
    "cynopsisName": null,
    "nationalityName": "Wallis and Futunan",
    "symbol": "WF",
    "flag": "https://flagcdn.com/w320/wf.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 34,
        "name": "CFP Franc",
        "symbol": "XPF",
        "currencySymbol": "₣",
        "imageUrl": "https://flagsapi.com/XPF/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 34,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:04:22.170990Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:04:22.170990Z"
  },
  {
    "id": 217,
    "name": "Curacao",
    "cynopsisName": null,
    "nationalityName": "Curacaoan",
    "symbol": "CW",
    "flag": "https://flagcdn.com/w320/cw.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 36,
        "name": "Netherlands Antillean Guilder",
        "symbol": "ANG",
        "currencySymbol": "ƒ",
        "imageUrl": "https://flagsapi.com/ANG/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 36,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      },
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:06:09.127645Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:06:09.127645Z"
  },
  {
    "id": 218,
    "name": "Guadeloupe",
    "cynopsisName": null,
    "nationalityName": "Guadeloupean",
    "symbol": "GP",
    "flag": "https://flagcdn.com/w320/gp.png",
    "hasBankTransfer": false,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:06:46.415189Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:06:46.415189Z"
  },
  {
    "id": 219,
    "name": "Martinique",
    "cynopsisName": null,
    "nationalityName": "Martinican",
    "symbol": "mq",
    "flag": "https://flagcdn.com/w320/mq.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:07:48.036071Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:07:48.036071Z"
  },
  {
    "id": 220,
    "name": "Puerto Rico",
    "cynopsisName": null,
    "nationalityName": "Puerto Rican",
    "symbol": "PR",
    "flag": "https://flagcdn.com/w320/pr.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": false,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": false,
    "localCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 37,
        "name": "Mexican Peso",
        "symbol": "MXN",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/MXN/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 37,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:08:56.319346Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:08:56.319346Z"
  },
  {
    "id": 221,
    "name": "Turks and Caicos Islands",
    "cynopsisName": null,
    "nationalityName": "Turks and Caicos Islander",
    "symbol": "TC",
    "flag": "https://flagcdn.com/w320/tc.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 18,
        "name": "Canadian Dollar",
        "symbol": "CAD",
        "currencySymbol": "C$",
        "imageUrl": "https://flagsapi.com/CA/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 18,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 20,
        "name": "British Pound",
        "symbol": "GBP",
        "currencySymbol": "£",
        "imageUrl": "https://flagsapi.com/GB/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 20,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:13:43.247556Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:13:43.247556Z"
  },
  {
    "id": 222,
    "name": "US Virgin Islands",
    "cynopsisName": null,
    "nationalityName": "US Virgin Islander",
    "symbol": "VI",
    "flag": "https://flagcdn.com/w320/vi.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": false,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": false,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:14:35.853828Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:14:35.853828Z"
  },
  {
    "id": 223,
    "name": "Faroe Islands",
    "cynopsisName": null,
    "nationalityName": "Faroese",
    "symbol": "FO",
    "flag": "https://flagcdn.com/w320/fo.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 38,
        "name": "Danish Krone",
        "symbol": "DKK",
        "currencySymbol": "kr",
        "imageUrl": "https://flagsapi.com/DKK/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 38,
          "maxDecimalPlaces": 1,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 20,
        "name": "British Pound",
        "symbol": "GBP",
        "currencySymbol": "£",
        "imageUrl": "https://flagsapi.com/GB/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 20,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      },
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:15:28.732356Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:15:28.732356Z"
  },
  {
    "id": 224,
    "name": "Greenland",
    "cynopsisName": null,
    "nationalityName": "Greenlandic",
    "symbol": "GL",
    "flag": "https://flagcdn.com/w320/gl.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 38,
        "name": "Danish Krone",
        "symbol": "DKK",
        "currencySymbol": "kr",
        "imageUrl": "https://flagsapi.com/DKK/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 38,
          "maxDecimalPlaces": 1,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 2,
        "name": "US Dollar",
        "symbol": "USD",
        "currencySymbol": "$",
        "imageUrl": "https://flagsapi.com/US/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 2,
          "maxDecimalPlaces": 3,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": true
        }
      },
      {
        "id": 18,
        "name": "Canadian Dollar",
        "symbol": "CAD",
        "currencySymbol": "C$",
        "imageUrl": "https://flagsapi.com/CA/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 18,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:17:06.065773Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:17:06.065773Z"
  },
  {
    "id": 225,
    "name": "Guernsey",
    "cynopsisName": null,
    "nationalityName": "Channel Islander",
    "symbol": "GG",
    "flag": "https://flagcdn.com/w320/gg.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": false,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": false,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 20,
        "name": "British Pound",
        "symbol": "GBP",
        "currencySymbol": "£",
        "imageUrl": "https://flagsapi.com/GB/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 20,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:17:48.026699Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:17:48.026699Z"
  },
  {
    "id": 226,
    "name": "Isle of Man",
    "cynopsisName": null,
    "nationalityName": "Manx",
    "symbol": "IM",
    "flag": "https://flagcdn.com/w320/im.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": false,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": false,
    "localCurrencies": [
      {
        "id": 20,
        "name": "British Pound",
        "symbol": "GBP",
        "currencySymbol": "£",
        "imageUrl": "https://flagsapi.com/GB/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 20,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:18:19.583121Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:18:19.583121Z"
  },
  {
    "id": 227,
    "name": "Jersey",
    "cynopsisName": null,
    "nationalityName": "Channel Islander\"",
    "symbol": "JE",
    "flag": "https://flagcdn.com/w320/je.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": false,
    "localCurrencies": [
      {
        "id": 20,
        "name": "British Pound",
        "symbol": "GBP",
        "currencySymbol": "£",
        "imageUrl": "https://flagsapi.com/GB/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 20,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:18:51.507817Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:18:51.507817Z"
  },
  {
    "id": 228,
    "name": "Falkland Islands",
    "cynopsisName": null,
    "nationalityName": "Falkland Islander",
    "symbol": "FK",
    "flag": "https://flagcdn.com/w320/fk.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": false,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": false,
    "localCurrencies": [
      {
        "id": 39,
        "name": "Falkland Islands Pound",
        "symbol": "FKP",
        "currencySymbol": "£",
        "imageUrl": "https://flagsapi.com/FKP/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 39,
          "maxDecimalPlaces": 1,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 20,
        "name": "British Pound",
        "symbol": "GBP",
        "currencySymbol": "£",
        "imageUrl": "https://flagsapi.com/GB/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 20,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:19:57.150597Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:19:57.150597Z"
  },
  {
    "id": 229,
    "name": "Saint Helena",
    "cynopsisName": null,
    "nationalityName": "Saint Helenian",
    "symbol": "SH",
    "flag": "https://flagcdn.com/w320/sh.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": false,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": false,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 40,
        "name": "Saint Helena Pound",
        "symbol": "SHP",
        "currencySymbol": "£",
        "imageUrl": "https://flagsapi.com/SHP/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 40,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 20,
        "name": "British Pound",
        "symbol": "GBP",
        "currencySymbol": "£",
        "imageUrl": "https://flagsapi.com/GB/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 20,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:32:30.905053Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:32:30.905053Z"
  },
  {
    "id": 230,
    "name": "MAYOTTE",
    "cynopsisName": null,
    "nationalityName": "Mahoran",
    "symbol": "YT",
    "flag": "https://flagcdn.com/w320/yt.png",
    "hasBankTransfer": true,
    "hasCashPickup": false,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 41,
        "name": "Comorian Franc",
        "symbol": "KMF",
        "currencySymbol": "CF",
        "imageUrl": "https://flagsapi.com/KMF/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 41,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:36:11.903376Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:36:11.903376Z"
  },
  {
    "id": 231,
    "name": "Reunion",
    "cynopsisName": null,
    "nationalityName": "Reunionese",
    "symbol": "RE",
    "flag": "https://flagcdn.com/w320/re.png",
    "hasBankTransfer": false,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 42,
        "name": "Mauritian Rupee",
        "symbol": "MUR",
        "currencySymbol": "₨",
        "imageUrl": "https://flagsapi.com/MUR/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 42,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:37:39.758122Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:37:39.758122Z"
  },
  {
    "id": 232,
    "name": "Western Sahara",
    "cynopsisName": null,
    "nationalityName": "SAHRAWI",
    "symbol": "EH",
    "flag": "https://flagcdn.com/w320/eh.png",
    "hasBankTransfer": true,
    "hasCashPickup": true,
    "hasIndividualSender": true,
    "hasOrganizationSender": true,
    "hasIndividualBeneficiary": true,
    "hasOrganizationBeneficiary": true,
    "localCurrencies": [
      {
        "id": 43,
        "name": "Moroccan Dirham",
        "symbol": "MAD",
        "currencySymbol": "د.م.",
        "imageUrl": "https://flagsapi.com/MAD/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 43,
          "maxDecimalPlaces": 2,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "foreignCurrencies": [
      {
        "id": 22,
        "name": "Euro",
        "symbol": "EUR",
        "currencySymbol": "€",
        "imageUrl": "https://flagsapi.com/EU/flat/64.png",
        "isEnabled": true,
        "currencySetting": {
          "id": 22,
          "maxDecimalPlaces": 5,
          "isCashWithdrawEnabled": false,
          "isWalletEnabled": false
        }
      }
    ],
    "countrySetting": null,
    "createdBy": "Nguyen",
    "createdDate": "2026-02-09T09:39:38.358473Z",
    "lastModifiedBy": "Nguyen",
    "lastModifiedDate": "2026-02-09T09:46:46.284607Z"
  }
];

export default countriesAll;
